import styled from "styled-components";

export const Container = styled.div`
  padding: 20px;
`;

export const Title = styled.h3`
  text-align: center;
  margin-bottom: 20px;
`;

export const SubTitle = styled.h4`
  margin-bottom: 20px;
`;
